import Vue from 'vue'
import Router from 'vue-router'
import Complaints from "../components/Complaints";
import Jump from "../components/Jump";
import FunctionReserved from "../components/FunctionReserved";
import ProblemDetail from "../components/ProblemDetail";
import Mofawu from "../components/Mofawu";
import QuestionFeedback from "../components/QuestionFeedback";
import ScanEwm from "../components/ScanEwm";

Vue.use(Router)
var router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'functionReserved',
      component: FunctionReserved
    },
    {//魔法屋
      path: '/mofawu',
      name: 'mofawu',
      component: Mofawu
    },
    {//问题反馈
      path: '/questionFeedback',
      name: 'questionFeedback',
      component: QuestionFeedback
    },
    {//详情
      path: '/problemDetail',
      name: 'problemDetail',
      component: ProblemDetail
    },
    {//测试
      path: '/jump',
      name: 'jump',
      component: Jump
    },
    {
      path: '/complaints',
      name: 'complaints',
      component: Complaints
    },{
      path: '/scanEwm',
      name: 'ScanEwm',
      component: ScanEwm
    },
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js